import React, { useState,useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom"; // ✅ Versión v5
import "./Preimportdeck.css";

import { API_URL } from "../../config/constants";

const PreimportDeck = () => {
    useEffect(() => {
    fetch(`${API_URL}/endpoint`)
      .then((res) => res.json())
      .then((data) => {
        console.log("Datos:", data);
      })
      .catch((error) => {
        console.error("Error al obtener datos:", error);
      });
  }, []);

    const [deckCode, setDeckCode] = useState("");
    const [cardDatabase, setCardDatabase] = useState([]);
    const [isImporting, setIsImporting] = useState(false);  

    const dispatch = useDispatch();
    const history = useHistory(); // ✅ v5 equivalent of useNavigate

    const editionMap = {
        es: "edition1",
        he: "edition2",
        hd: "edition3",
        ra: "edition4"
    };

    const importDeck = async () => {
        setIsImporting(true); // 🔹 Activa el spinner
        if (!deckCode) {
            alert("Por favor, ingresa un código de mazo.");
            return;
        }

        try {
            const previewResponse = await fetch(`${API_URL}/import`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ deck_code: deckCode })
            });

            if (!previewResponse.ok) throw new Error(`Error HTTP preview: ${previewResponse.status}`);

            const previewData = await previewResponse.json();
            const card = previewData?.deck?.cards;
            if (!card || Object.keys(card).length === 0) {
                alert("⚠️ No se encontró el mazo o está vacío.");
                return;
            }

            const key = Object.keys(card)[0];
            const keyPrefix = key.slice(0, 2);
            const editionFromKey = editionMap[keyPrefix] || "desconocida";

            console.log("🔑 Llave:", key);
            console.log("📦 Edición detectada:", editionFromKey);

            const cartasResponse = await fetch(`${API_URL}/cartas?edition=${editionFromKey}`);
            const cartasData = await cartasResponse.json();
            const database = cartasData.data.map(entry => entry);
            setCardDatabase(database);

            const response = await fetch(`${API_URL}/import`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ deck_code: deckCode })
            });

            if (!response.ok) throw new Error(`Error HTTP final: ${response.status}`);

            const data = await response.json();

            const enrichDeckData = (deck, database) => ({
                ...deck,
                cards: Object.entries(deck.cards).map(([id, quantity]) => {
                    const cardInfo = database.find(card => card.Id == id) || {};
                    if (!cardInfo) {
                        console.warn(`⚠️ Carta con ID ${id} no encontrada en la base de datos`);
                    }
                    return {
                        ...cardInfo,
                        quantity,
                        mini_img: cardInfo.mini_img || "URL_IMAGEN_DEFECTO"
                    };
                })
            });

            const enrichedPayload = enrichDeckData(data.deck, database);
            const formattedDeck = Object.values(enrichedPayload.cards);

            dispatch({ type: "IMPORT_DECK", payload: formattedDeck });
            dispatch({ type: "UPDATE_DECK_GROUPS" });

            // ✅ Redirigir usando history.push en v5
            history.push(`/crear?edition=${editionFromKey}`);

        } catch (error) {
            console.error("⚠️ Error al importar:", error);
        } finally {
        setIsImporting(false); // 🔹 Desactiva el spinner al finalizar
    }
    };

    return (
        <div className="preimport">
            <h2>Importar Mazo</h2>
            <div className="preimport-container">
                <input
                    type="text"
                    value={deckCode}
                    onChange={(e) => setDeckCode(e.target.value)}
                    onKeyDown={(e) => {
                    if (e.key === "Enter") importDeck();
                    }}
                    placeholder="Introduce el código del mazo"
                    className="preimport-input"
                />

                <button onClick={importDeck} className="preimport-button" disabled={isImporting}>
                {isImporting ? (
                    <i className="fa-solid fa-spinner fa-spin"></i>
                ) : (
                    <i className="fa-solid fa-file-import"></i>
                )}
                </button>
            </div>
        </div>
    );
};

export default PreimportDeck;
